import Link from 'next/link';

import { useTrackViewedLibrary } from '@air/analytics';
import { SidebarNavigationItem } from '@air/component-sidebar-navigation';
import { ImageSearchLegacyIcon } from '@air/design-icons';

import { Routes } from '~/constants/routes';
import { useIsActiveRoute } from '~/hooks/useIsActiveRoute';
export const SidebarNavigationItemAll = () => {
  const { isActiveRoute } = useIsActiveRoute({ route: Routes.media.all });
  const { trackViewedLibrary } = useTrackViewedLibrary();

  return (
    <SidebarNavigationItem
      asChild
      data-id="all"
      onClick={trackViewedLibrary}
      prefix={<ImageSearchLegacyIcon className="size-4" />}
      state={isActiveRoute ? 'active' : 'default'}
    >
      <Link href={Routes.media.all}>Search all files</Link>
    </SidebarNavigationItem>
  );
};
